"use strict";

exports.__esModule = true;
exports.InputGroup = InputGroup;

var _react = _interopRequireDefault(require("react"));

var _reactUtils = require("@okee-uikit/react-utils");

var _reactConfig = require("@okee-uikit/react-config");

var _excluded = ["className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function InputGroup(props) {
  var className = props.className,
      extra = _objectWithoutPropertiesLoose(props, _excluded);

  var rtl = (0, _reactConfig.useDirection)() === 'rtl';
  var cls = (0, _reactUtils.classnames)((0, _reactConfig.usePrefixCls)('input-group', {
    rtl: rtl
  }), className);
  return _react.default.createElement("span", _extends({}, extra, {
    className: cls
  }));
}